import { API } from 'lib/api';
import { USER_ENDPOINTS } from 'constant/endpoints/user';
import type {
  IUser,
  IUserDropdownResponse,
  IUserListParams,
} from 'types/User/user';

export const fetchUserList = async (
  params?: IUserListParams,
): Promise<IUserDropdownResponse> => {
  const { data } = await API.get(USER_ENDPOINTS.GET_USERS, {
    params,
  });
  return data;
};

export const fetchApprovers = async (): Promise<IUserDropdownResponse> => {
  const { data } = await API.get(USER_ENDPOINTS.GET_APPROVERS);
  return data;
};

export const getUserData = async (): Promise<IUser> => {
  const { data } = await API.get(USER_ENDPOINTS.GET_USER_DATA);
  return data;
};
